
const isLocalBrowser =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || (isLocalBrowser ? "http://localhost:5000" : "");

export default API_BASE_URL;
